export default __webpack_public_path__ + "static/media/Snd_TryY.3589715c.mp3";